require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// /home/justin/dev/todomvc-liveresource-website/~/core-js/modules/es7.symbol.observable.js
// module id = 543
// module chunks = 0